import { sb } from '../supabase';

// Growth OS is owner-only, and the SERVER decides who the owner is
// (public.is_growth_owner(), 20261101153415_growth_os_owner_gate.sql). Not the
// role: there is more than one super_admin. Any error — including the function
// not existing yet — answers "no", so the item stays hidden rather than open.
export async function fetchIsGrowthOwner() {
  try {
    const { data, error } = await sb.rpc('is_growth_owner');
    if (error) return false;
    return data === true;
  } catch {
    return false;
  }
}
